<template>
    <div class="popBg">
        <div class="popBox" :style="{width: width, height: height}">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    <span>{{comTitle}}</span>
                </div>
                <div class="popBody" ref="popBody">
                    <div v-for="(v, i) in comListData" :key="i" class="text item" :data-val="v.value" @click="checkedData">
                        <el-radio v-model="comCheckedVal" :label="v.value">{{v.label}}</el-radio>
                    </div>
                </div>
                <div class="popFoot">
                    <el-button size="medium" type="primary" @click="success">确定</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button size="medium" @click="cancel">取消</el-button>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "PopRadio",
        data: () => ({
            comTitle: "请选择",
            comCheckedVal: "3",
            comListData: [
                // {label: "1号理发店", value: "1"},
            ]
        }),
        props: ["title", "value", "listData", "width", "height"],
        methods: {
            checkedData: function (ev) {
                let val = ev.target.getAttribute("data-val");
                this.comCheckedVal = val;
            },
            success: function () {
                this.$emit("checked", this.comCheckedVal);
            },
            cancel: function () {
                this.$emit("checked", false);
            },
            init: function () {
                if(!obj.isNull(this.title))
                    this.comTitle = this.title;
                if(!obj.isNull(this.value))
                    this.comCheckedVal = this.value;
                if(!obj.isNull(this.listData))
                    this.comListData = this.listData;
            }
        },
        mounted: function(){
            this.init();
        },
        updated: function(){
            obj.unScrollbar(this.$refs["popBody"]);
            obj.scrollbar(this.$refs["popBody"]);
        },
        watch: {
            listData: function (newData) {
                this.comListData = newData;
            }
        }
    }
</script>

<style scoped>
    .popBg{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        left: 0;
        top: 0;
    }
    .popBox{
        margin: 50px auto 0;
        width: 400px;
    }
    .popBox .title{
        font-size: 16px;
    }
    .popBody{
        max-height: 300px;
    }
    .popFoot{
        padding-top: 20px;
        text-align: center;
    }
    .popBox .item{
        padding: 10px 20px;
    }
    .popBox .item:hover{
        background: #f2f2f2;
    }
</style>
